export default __webpack_public_path__ + "static/media/Rectangle 95.94eb37c9.png";